import { useEffect, useRef } from "react";
import dinoGif from "./assets/dinogif.gif";

export default function WelcomeSection() {
  const canvasRef = useRef(null);
  const dropsRef = useRef([]);
  const columnsRef = useRef(0);
  const fontSize = 8;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationFrameId;

    const letters = "01".repeat(6).split("");

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      const columns = Math.floor(canvas.width / fontSize);
      if (columns > columnsRef.current) {
        dropsRef.current.push(...Array(columns - columnsRef.current).fill(1));
      }
      columnsRef.current = columns;
    };

    resizeCanvas();

    if (dropsRef.current.length === 0) {
      dropsRef.current = Array.from({ length: columnsRef.current }, () => 1);
    }

    const draw = () => {
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, "#A020F0");
      gradient.addColorStop(0.4, "#C71A5C");
      gradient.addColorStop(1, "#C71A5C");

      dropsRef.current.forEach((drop, i) => {
        const text = letters[Math.floor(Math.random() * letters.length)];

        ctx.fillStyle = gradient;
        ctx.shadowBlur = 5;
        ctx.shadowColor = "#A020F0";

        ctx.fillText(text, i * fontSize, drop * fontSize);

        ctx.shadowBlur = 0;

        dropsRef.current[i] += 0.6;

        if (dropsRef.current[i] * fontSize > canvas.height && Math.random() > 0.995) {
          dropsRef.current[i] = 0;
        }
      });

      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      columnsRef.current = Math.floor(canvas.width / fontSize);
      if (columnsRef.current > dropsRef.current.length) {
        dropsRef.current.push(...Array(columnsRef.current - dropsRef.current.length).fill(1));
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <section className="welcome-section">
      <canvas ref={canvasRef} className="matrix-canvas" />
      <div className="content">
        <div className="error-wrapper">
          <h2 className="error-code">Registration Full!</h2>
          <img
            src={dinoGif}
            alt="Dino"
            className="dino-icon"
          />
        </div>

        <p className="subtitle">Wow! Thank you for the incredible interest. We've officially reached our maximum number of participants.</p>
        <p className="subtitle">Don't lose hope! Join our waiting list below and we will contact you if a spot becomes available.</p>
        <button
          onClick={() => window.open('https://forms.gle/tayug8VPAoxo6mdR9', '_blank')}
          className="home-button"
        >
          Join Waiting List
        </button>
        <a className="learn-more" href="#About">Learn more</a>
      </div>

      <a href="#About" className="scroll-down-arrow" aria-label="Scroll down">
        <svg width="80" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
    </section>
  );
}